import { GUEST_AVATAR_PATH } from '@/modules/misc/common/navbar/config.json';

import { updateProfilePicture } from './updateProfilePicture';

export function updateUserName({ username, isUC = false }) {
  if (!username) {
    return;
  }
  const userNameElement = document.getElementById('userName');
  if (!userNameElement) {
    return;
  }

  const btnWrapper = document.querySelector('.ds-header__navbar__avatar__btn_img');
  const img = document.getElementById('profilePicture');

  let nick = username;
  // remove chars in parentheses
  nick = nick.replace(/\(.*\)/, '');
  // remove special chars but keep spaces
  nick = nick.replace(/[^a-zA-Z ]/g, '');
  // remove double spaces
  nick = nick.replace(/\s\s+/g, ' ');

  let initials = nick.trim().split(' ');
  initials = initials[0].charAt(0) + (initials.length > 1 ? initials[initials.length - 1].charAt(0) : '');
  initials = initials.toUpperCase();
  if (isUC && btnWrapper && (!img || (img && img.src.includes(GUEST_AVATAR_PATH)))) {
    btnWrapper.innerHTML = '';
    btnWrapper.textContent = initials;
  }

  btnWrapper.dataset.initials = initials;
  userNameElement.innerText = username;

  if (initials.length === 0) {
    updateProfilePicture(GUEST_AVATAR_PATH);
  }
}
